<template>
  <div class="w-full">
    <vs-card
      id="entry-donut-loading"
      class="
        vs-con-loading__container
        px-2
        widget-card
        altura
        ligthMode
        darkModeCard
      "
      style="position: sticky"
    >
      <vs-row>
        <vs-col>
          <card-header
            :title="$t('pallets_in_warehouse_by_client')"
            class=""
          ></card-header>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col>
          <div class="body-card-widget">
            <apexcharts
              class="mt-12 mb-8"
              type="donut"
              height="250%"
              :options="chartOptions"
              :series="series"
              :chartId="'pallets'"
            ></apexcharts>
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import dashboardTV from '@/http/requests/dashboard'
import CardHeader from './CardHeader.vue'
import loading from '@/mixins/Loading.js'

export default {
  mixins: [loading],
  props: {
    refresh: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    apexcharts: VueApexCharts,
    CardHeader,
  },
  computed: {
    isLoading() {
      return this.loading.entry_donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('entry-donut-loading')
      } else {
        this.closeLoading('entry-donut-loading')
      }
    },
  },
  data: function () {
    return {
      loading: {
        entry_donut: false,
      },
      series: [],
      chartOptions: {
        labels: [],
        chart: {
          id: 'pallets',
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  label: '',
                  formatter: function (w) {
                    let total = 0
                    w.globals.seriesTotals.forEach((element) => {
                      total = total + parseInt(element)
                    })
                    return total
                  },
                },
                value: {
                  show: true,
                  color: '#fff',
                  fontSize: '30px',
                },
                name: {
                  show: false,
                },
              },
            },
          },
        },
        stroke:{
         colors:['#273045']
        },
        
      },
      allPallets: null,
      colors: [],
    }
  },
  methods: {
    getPalletsWarehouse() {
      this.loading.entry_donut = true
      dashboardTV
        .palletWarehouseDonut()
        .then((res) => {
          this.allPallets = res.data.data
          this.setPalletsWarehouse()
        })
        .catch((err) => {
          console.log(err)
          this.loading.entry_donut = false
        })
    },
    setPalletsWarehouse() {
      if (this.allPallets.length == 0) {
        this.series = [1]
        this.chartOptions.labels = ['NO INFO']
        this.colors = ['#626262']
        this.resertDonut()
      } else {
        for (let i = 0; i < this.allPallets.length; i++) {
          this.chartOptions.labels[i] = this.allPallets[i].ClientName
          this.series[i] = parseInt(this.allPallets[i].total)
          this.colors[i] = this.allPallets[i].color
        }
        this.resertDonut()
      }
    },
    resertDonut() {
      ApexCharts.exec('pallets', 'updateOptions', {
        labels: this.chartOptions.labels,
        series: this.series,
        fill: {
          colors: this.colors,
        },
      })
      this.loading.entry_donut = false
    },
  },
  mounted() {
    this.getPalletsWarehouse()
    if (this.refresh === true) {
      var v = this
      setInterval(function () {
        v.getPalletsWarehouse()
      }, process.env.VUE_APP_CHART_RELOAD_TIME)
    }
  },
}
</script>
<style>
.card-style {
  height: 80vh;
}
</style>